import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

export const schema = {
  type: 'object',
  properties: {
    stage: {
      title: 'stage',
      type: 'string',
      enum: [''],
      enumNames: ['chooseOption'],
      default: ''
    },
    roles: {
      title: 'roles',
      type: 'array',
      minItems: 1,
      items: {
        type: 'string',
        enum: [],
        enumValues: []
      },
      uniqueItems: true
    }
  },
  required: ['stage', 'roles']
};

export const uiSchema = {
  'ui:rootFieldId': 'form-stages',
  stage: {
    'ui:field': 'Select',
    classNames: 'form-control-parent'
  },
  roles: {
    'ui:field': 'MultiSelect',
    classNames: 'form-control-parent'
  }
};

export const translateSchema = (inputSchema) => {
  function translateProperties (inputProperties) {
    const outputProperties = inputProperties;
    const keys = Object.keys(inputProperties);
    for (let i = 0; i < keys.length; i++) {
      if (inputProperties[keys[i]].title) outputProperties[keys[i]].title = funcTranslateHelper(`Builder:Stages:form:${inputProperties[keys[i]].title}`);
      if (inputProperties[keys[i]].placeholder) outputProperties[keys[i]].placeholder = funcTranslateHelper(`Builder:Stages:form:${inputProperties[keys[i]].placeholder}`);
      if (inputProperties[keys[i]].enumNames) outputProperties[keys[i]].enumNames = outputProperties[keys[i]].enumNames.map(element => funcTranslateHelper(`Builder:Stages:form:${element}`));
    }

    return outputProperties;
  }

  inputSchema.properties = translateProperties(inputSchema.properties);
}
;
